const assignImportantRules = (editor) => {

    editor.on('styleable:change', (model, property) => { 
        const value = model.getStyle()[property];               
        if(value !== undefined && value.includes !== undefined && value.indexOf('!important') === -1 ){
          model.addStyle({ [property]: `${value} !important` });
        }
      });
}

export default assignImportantRules;
